module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
(function(fox) {
	fox.registerWidget('Menu2', {

		running: function () {
			this.mapMenu = fox.site.getOption('map.menu');

			if (!this.mapMenu) {
				return this.callParent('running', arguments);
			}

			this.handleEvent(fox.wom.selectFirst('@root #navi'), 'modified_0', fox.bind(function (page) {
				this._handleNaviChange(page);
			}, this));

			this.callParent('running', arguments);
		},

		_handleNaviChange: function (page) {
			var sectionMatch = false;
			if (fox.isEmpty(page)) {
				page = 'home';
			}

			fox.each(this.mapMenu, function (pages, section) {
				if (section == page) {
					sectionMatch = true;
					this.dispatchEvent('pageChanged', {section: section, page: page});
				}
			}, this);

			if (!sectionMatch) {
				fox.each(this.mapMenu, function (pages, section) {

					fox.each(pages, function (list, alias) {
						if (fox.inArray(list, page)) {
							this.dispatchEvent('pageChanged', {section: section, page: alias});
						}	
					}, this);

				}, this);
			}
		}

	}, 'Controller');
})(fox);
 /* fox-dynamic-injection */ 
};


//////////////////
// WEBPACK FOOTER
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/node_modules/fox-core-resource/lib/widgets/menu/menu2.js
// module id = 207
// module chunks = 0